import React, {useCallback, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';

//Components
import HostInfoUI from '../../../../../stories/components/hotels/DetailsPageUnif/HostInfoUI/HostInfoUI';
import HostDetailsModal from '../../../../../stories/components/hotels/DetailsPageUnif/HostInfoUI/HostDetailsModal/HostDetailsModal';
import Modal, {useModal} from '@stencil/hotels-modal-component';

//Analytics
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';

//Icons
import HappyLanguageIcon from '@stencil/icons/src/HappyLanguageIcon/HappyLanguageIcon';
import HappyScheduleIcon from '@stencil/icons/src/HappyScheduleIcon/HappyScheduleIcon';

//Types
import {HostInfoShape} from '@stencil/hotels-cg-reducer/src/details/types';

interface HostInfoProps {
  hostInfo: HostInfoShape;
}

const HostInfo: React.FC<HostInfoProps> = ({hostInfo}) => {
  const dispatch = useDispatch();
  const {isModalOpen, closeModal, openModal} = useModal();

  const [showFullHostImage, setShowFullHostImage] = useState(false);

  const closeHostModal = () => {
    setShowFullHostImage(false);
    closeModal();
  };

  const onReadMoreClick = () => {
    openModal();
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: detailsClick.hostInfo.hostCardClicked,
          type: omnitureConfig.ctaType.Button,
          componentName: DetailsPageComponents.HostInfo,
          destination: '',
        },
      }),
    );
  };

  const onHostImageClick = () => {
    openModal();
    setShowFullHostImage(true);
    dispatch(
      omnitureThunk(omnitureConfig.pages.DetailsUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: detailsClick.hostInfo.hostPhotoClicked,
          type: omnitureConfig.ctaType.Card,
          componentName: DetailsPageComponents.HostInfo,
          destination: '',
        },
      }),
    );
  };

  const mergedIconsAndText = {
    langaugeIcon: {
      text: hostInfo?.language,
      icon: <HappyLanguageIcon margin="0 0.5rem 1rem 0" />,
    },
    happyTimeIcon: {
      text: hostInfo?.timeSinceHostingOnMmt,
      icon: <HappyScheduleIcon fill="#000" margin="0 2px 0 0" />,
    },
  };

  const renderHostListInfo = useCallback(
    ({removeText = ''}: {removeText?: string} = {}) => {
      return (
        <>
          {Object.values(mergedIconsAndText).map(item => {
            if (removeText === item.text) {
              return null;
            }

            return (
              !!item.text &&
              !!item.icon && (
                <li key={item.text}>
                  {item.icon}
                  <span dangerouslySetInnerHTML={{__html: item.text}} style={{marginLeft: '5px'}} />
                </li>
              )
            );
          })}
        </>
      );
    },
    [hostInfo],
  );

  return (
    <>
      <HostInfoUI
        hostInfo={hostInfo}
        onReadMoreClick={onReadMoreClick}
        renderHostListInfo={renderHostListInfo}
        onHostImageClick={onHostImageClick}
      ></HostInfoUI>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeHostModal}
        modalStyles={{
          width: showFullHostImage ? '630px' : '692px',
        }}
      >
        <HostDetailsModal
          hostInfo={hostInfo}
          renderHostListInfo={renderHostListInfo}
          showFullHostImage={showFullHostImage}
        />
      </Modal>
    </>
  );
};

export default HostInfo;
